export const GET_CREDIT_DEBIT = 'GET_CREDIT_DEBIT';
export const GET_CREDIT_DEBIT_SUCCESS = 'GET_CREDIT_DEBIT_SUCCESS';
export const GET_CREDIT_DEBIT_FAIL = 'GET_CREDIT_DEBIT_FAIL';

export const ADD_CREDIT_DEBIT = 'ADD_CREDIT_DEBIT';
export const ADD_CREDIT_DEBIT_SUCCESS = 'ADD_CREDIT_DEBIT_SUCCESS';
export const ADD_CREDIT_DEBIT_FAIL = 'ADD_CREDIT_DEBIT_FAIL';